import { config } from '../config';
import { TimeSlot, Store } from '../types/model';

export const baseUrl = `/${config.country}/${config.language}/stores/events`;

export const getCredentialUrl = (url: string) =>
  url.replace('{from}', `from=${window.location.href}`);

export const intlLocale =
  config.intlLocale || `${config.language}-${config.country}`;

const useOtherName =
  (['jp', 'kr'].includes(config.country) && config.language === 'en') ||
  (config.country === 'ca' && config.language === 'fr');

export const getStoreDisplayName = (store: Store): string =>
  useOtherName
    ? store.storeOtherName || store.storeName || ''
    : store.storeName || '';

export const isRegistrationClosed = (
  closeDate: number | undefined,
  now?: Date
) => {
  if (!closeDate) {
    return true;
  }
  const closingTime = now ? +now : Date.now();
  return +new Date(closeDate) < closingTime;
};

export const isTimeSlotFullyBooked = (timeSlot: TimeSlot) =>
  timeSlot?.remainingSpots === 0 && !timeSlot?.registerToWaitingList;

export const isTimeSlotExpired = (timeSlot: TimeSlot) => {
  if (!timeSlot || !timeSlot.utcStartDate) {
    return false;
  }
  return toTimestamp(timeSlot.utcStartDate) < Date.now();
};

export function isObjectEmpty(x: Object) {
  if (!x) {
    return true;
  }

  return Object.keys(x).length === 0;
}

export function getEventIdFromSlug(slug: string) {
  const [name, eventId] = slug.split('--');
  if (!eventId) {
    return name;
  }
  return eventId;
}

export const toTimestamp = (ts: number): number => ts * 1e3;

const storeNameCollator = new Intl.Collator(intlLocale, {
  usage: 'sort',
  sensitivity: 'base',
  numeric: true,
  ignorePunctuation: true,
});

export function sortStores(a: Store, b: Store) {
  const nameA = getStoreDisplayName(a);
  const nameB = getStoreDisplayName(b);
  return storeNameCollator.compare(nameA.normalize('NFKC'), nameB.normalize('NFKC'));
}